import {useDispatch} from 'react-redux';
import {AffiliateSignup} from '../../../reducers/modals-action/actions';
import PurpleButton from '../../components/purple-button';
import ModalsLib from '../../../lib/modals';

export default ({game, close}) => {
    const dispatch = useDispatch();

    return (
        <div className="action-modal-body-container">
            <div className="choose-stage-top">
                <div className="left">
                    <div className="title">WELCOME<br/>PACKAGE</div>
                    <div className="text">Your bonus sparks to life once you choose your thrill.</div>
                    <div className="bonuses">
                        <div className="bonus">
                            <div className="bonus-info">
                                <span>100%</span>
                                Deposit bonus
                            </div>
                            <div className="line"></div>
                        </div>
                        <div className="bonus">
                            <div className="bonus-info">
                                <span>$5</span>
                                Freeplay
                            </div>
                            <div className="line"></div>
                        </div>
                    </div>
                </div>
                <div className="right">
                    <div className="close" onClick={e => close()}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6 18L18 6" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M18 18L6 6" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                    <div className="girl"></div>
                </div>
            </div>
            <div className="stage-body">
                <div className="game-select">
                    <div className="left">
                        <div className="image">
                            {game ? (
                                <img src={`${window.location.origin}/source/system/games/${game.slug}.png`} />
                            ) : (
                                <svg width="15" height="22" viewBox="0 0 15 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M5.44304 14.853V14.1126C5.44304 13.4377 5.61181 12.788 5.94937 12.1635C6.29747 11.5288 6.71414 10.9698 7.19937 10.4863C7.69515 10.0027 8.18565 9.53938 8.67089 9.09615C9.16667 8.64286 9.58333 8.17445 9.92089 7.69093C10.269 7.20742 10.443 6.73901 10.443 6.28571C10.443 5.64103 10.1846 5.12225 9.66772 4.7294C9.15084 4.32647 8.46519 4.125 7.61076 4.125C6.75633 4.125 5.923 4.34158 5.11076 4.77473C4.29852 5.20788 3.5654 5.81731 2.91139 6.60302L0 3.77747C0.981013 2.58883 2.1519 1.66209 3.51266 0.997253C4.87342 0.332418 6.31857 0 7.8481 0C9.88397 0 11.5823 0.574176 12.943 1.72253C14.3143 2.87088 15 4.28114 15 5.9533C15 6.73901 14.8207 7.48947 14.462 8.20467C14.1139 8.9098 13.6867 9.51419 13.1804 10.0179C12.6846 10.5215 12.1888 11 11.693 11.4533C11.1973 11.8965 10.77 12.3448 10.4114 12.7981C10.0633 13.2514 9.88924 13.6896 9.88924 14.1126V14.853H5.44304ZM7.67405 22C6.85127 22 6.17089 21.7482 5.63291 21.2445C5.09494 20.7308 4.82595 20.0861 4.82595 19.3104C4.82595 18.5348 5.09494 17.8951 5.63291 17.3915C6.17089 16.8777 6.85127 16.6209 7.67405 16.6209C8.48629 16.6209 9.16667 16.8777 9.71519 17.3915C10.2637 17.9052 10.538 18.5449 10.538 19.3104C10.538 20.076 10.2637 20.7157 9.71519 21.2294C9.16667 21.7431 8.48629 22 7.67405 22Z" fill="#3C4352"/>
                                </svg>
                            )}
                        </div>
                        <div className="game-info">
                            <div className="label">Selected game</div>
                            <div className="value">{!game ? `Not selected` : game.name}</div>
                        </div>
                    </div>

                    <div className={`button ${game ? '' : 'active'}`} onClick={e => {
                        ModalsLib.open('changeGame', {
                            redirect: false,
                            welcome_bonus: true,
                            handler: e => dispatch(AffiliateSignup.selectGame(e))
                        });
                    }}>
                        {game ? (
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12.4082 4.23333C11.6832 4.01667 10.8832 3.875 9.9999 3.875C6.00824 3.875 2.7749 7.10833 2.7749 11.1C2.7749 15.1 6.00824 18.3333 9.9999 18.3333C13.9916 18.3333 17.2249 15.1 17.2249 11.1083C17.2249 9.625 16.7749 8.24167 16.0082 7.09167" stroke="#DFDFEC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M13.4415 4.43333L11.0332 1.66666" stroke="#DFDFEC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M13.4416 4.43333L10.6333 6.48333" stroke="#DFDFEC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>

                        ) : (
                            <svg width="8" height="15" viewBox="0 0 8 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0.75 13.95L6.18333 8.51667C6.825 7.875 6.825 6.825 6.18333 6.18333L0.75 0.75" stroke="#DFDFEC" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        )}
                    </div>
                </div>

                <PurpleButton onClick={e => {
                    if(!game)
                        ModalsLib.open('changeGame', {
                            redirect: false,
                            welcome_bonus: true,
                            handler: e => dispatch(AffiliateSignup.selectGame(e))
                        });

                    if(game)
                        dispatch(AffiliateSignup.setStage('signup'))
                }}>
                    {game ? `Continue` : 'Choose game'}
                </PurpleButton>

                <div className="stage-progress">
                    <div className="map">
                        <div className="dot active"></div>
                        <div className="line"></div>
                        <div className="dot active"></div>
                        <div className="line"></div>
                        <div className="dot active"></div>
                        <div className="line"></div>
                        <div className="dot active bonus">
                            <img src={`${window.location.origin}/source/system/modals-action/affiliate-signup/gift.png`} />
                        </div>
                    </div>
                    <div className="stages">
                        <span className="active">Choose game</span>
                        <span>Sign Up</span>
                        <span>Notifications</span>
                        <span>Claim Bonus</span>
                    </div>
                </div>
            </div>
        </div>
    )
}